/* ============================================================================
   Night Operators PREDATOR kit engine + kit selector (assets/predator-kit.js)
   Branch PREDATOR-LIVE (2026-09-04), PREDATOR-LIVE-2 (2026-09-04, second pass)
   PDP-KIT-3 (2026-09-04, third pass: the helmet row is now whichever helmet the
   visitor's market resolves, GEN II inside the US and GEN I outside it, and its
   option dropdowns are built from the theme's own picker markup) and PDP-KIT-4
   (2026-09-04, fourth pass: the free bridge is CLAIMED automatically by the two
   tiers whose flat lay shows it, and the helmet row carries its compare at price).
   No framework, no build step, no postMessage.

   Loaded (defer) by the KIT SELECTOR custom_liquid block inside the main-product
   section of templates/product.predator-live.json. Owns:
     1. the kit state machine: tier + add-ons with the Lovable Eb() rule both ways
        (ticking moves the tier UP, unticking an included item moves it DOWN),
        the free bridge claim (REDEEM / unclaim, default claimed, sessionStorage),
        and the optional GEN II FAST SF helmet upsell (US market only, variant picked)
     2. the kit selector DOM (#no-predator-kit)
     3. the theme's own Add to cart button on this template (intercepted so the
        whole component set goes into ONE /cart/add.js call)
     4. the theme price block (price / compare / SAVE badge follow the kit)
     5. the DropLock countdown (locked until 2026-09-04 14:00 UTC, like the lander)
   Exposes window.NOPredatorKit so assets/predator-lander.js (the ported lander)
   drives the same state from the lander's buy box, IN THE BOX section and the
   CLAIM FREE BRIDGE controls, in both directions.

   Cart: fetch('/cart/add.js') with {items:[...]} exactly like assets/pvs14-lander.js,
   plus the Dawn/Shrine `sections` request so the theme's own cart drawer can render
   the result; if the drawer cannot be driven the customer lands on /cart.
   The bridge line is sent ONLY while it is claimed (Bon 2026-09-04).
   ========================================================================== */
(function () {
  'use strict';
  if (window.NOPredatorKit) return;

  /* ---------------------------------------------------------------- facts */
  var VARIANTS = {
    core: 51445830713590,      // PREDATOR-CORE $749.95
    bridge: 51495664222454,    // PRED-BRIDGE $179.95, automatic discount makes it $0 with a core in the cart
    lens13: 51495578239222,    // PRED-LENS-13MM $199.95
    g24: 49798441795830,       // G24ALLU $99.95
    flip: 51495666548982       // PRED-FLIP $179.95
  };
  var ADDON_PRICE = { lens13: 199.95, g24: 99.95, flip: 179.95 };
  var BRIDGE_VALUE = 179.95;
  var TIERS = {
    core:     { id: 'core',     name: 'CORE',         price: 749.95,  compare: 1499.95, lens13: false, g24: false, flip: false },
    headworn: { id: 'headworn', name: 'MOUNT KIT',    price: 949.95,  compare: 1899.95, lens13: false, g24: true,  flip: true  },
    loadout:  { id: 'loadout',  name: 'FULL LOADOUT', price: 1049.95, compare: 2299.95, lens13: true,  g24: true,  flip: true  }
  };
  var DROP_MS = Date.UTC(2026, 8, 4, 14, 0, 0, 0); // 2026-09-04 10:00 ET, same constant as the Lovable bundle
  var BRIDGE_KEY = 'predator:bridge-claimed';        // same key as the Lovable page; "1" claimed, "0" unclaimed

  /* ---------------------------------------------------------------- helpers */
  function fmt(n) {
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function fmtWhole(n) {
    var whole = Math.abs(n - Math.round(n)) < 0.005;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
  }
  function pad(n, w) { n = String(Math.max(0, n)); while (n.length < (w || 2)) n = '0' + n; return n; }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function round2(n) { return Math.round(n * 100) / 100; }

  /* ---------------------------------------------------------------- drop lock */
  var dropOverride = null;
  try {
    var q = (window.location.search || '').match(/[?&]predator_drop=(open|locked)/);
    if (q) { dropOverride = q[1]; try { localStorage.setItem('no_predator_drop', q[1]); } catch (e) {} }
    else { dropOverride = localStorage.getItem('no_predator_drop'); }
  } catch (e) { dropOverride = null; }
  function remainingMs() {
    if (dropOverride === 'open') return 0;
    if (dropOverride === 'locked') return Math.max(1000, DROP_MS - Date.now());
    return Math.max(0, DROP_MS - Date.now());
  }
  function isLocked() { return remainingMs() > 0; }
  function parts(ms) {
    return { days: Math.floor(ms / 864e5), hours: Math.floor(ms / 36e5) % 24, minutes: Math.floor(ms / 6e4) % 60, seconds: Math.floor(ms / 1e3) % 60, millis: ms % 1e3 };
  }
  function clock(ms) { var p = parts(ms); return pad(p.days) + ':' + pad(p.hours) + ':' + pad(p.minutes) + ':' + pad(p.seconds); }

  /* ---------------------------------------------------------------- state */
  // Effective set. The Lovable rule (Eb): g24 && flip ? (lens13 ? loadout : headworn) : core.
  // It is applied in BOTH directions: ticking moves the tier up, unticking an item a tier
  // includes moves it down to the tier that still fits (Bon 2026-09-04).
  var bridgeDefault = true;
  try { var stored = sessionStorage.getItem(BRIDGE_KEY); if (stored === '0') bridgeDefault = false; } catch (e) {}
  var state = { tier: 'core', lens13: false, g24: false, flip: false, bridge: bridgeDefault, helmet: null };
  var subs = [];
  function mapTier(s) { return (s.g24 && s.flip) ? (s.lens13 ? 'loadout' : 'headworn') : 'core'; }

  /* ------------------------------------------------------------ PDP-KIT-4, Bon 2026-09-04

     "Checking mount kit and full loadout in product info section in shopify predator page
     should auto redeem/check the dual dovetail bridge checkbox since it exists in the flat
     lay images. just like the lovable section logic its the same."

     The rule, stated once and applied in exactly one place so nothing can drift:

       MOUNT KIT and FULL LOADOUT CLAIM the bridge. CORE does not touch it.

     WHY THOSE TWO AND NOT CORE. Bon's reason is the picture: the bridge is physically in
     the HEADWORN and FULL LOADOUT flat lays, so a customer who picks one of those tiers is
     looking at a bridge and must not have to tick a second box to get it. The CORE flat lay
     does not show one, so CORE keeps the behaviour it has today (bridge claimed by default,
     the customer's own choice remembered in sessionStorage) and nothing about that changes.

     WHY IT IS "the same as the lovable section logic". On the Lovable page an add on that a
     tier INCLUDES is shown ticked and reading INCLUDED, driven by the tier rather than by
     the customer, and that is exactly what tierClaimsBridge does for the bridge here. Read
     from the published bundle today, the Lovable page's own claim store (Ib / Pb / Ob on
     the sessionStorage key predator:bridge-claimed) is driven ONLY by its claim buttons and
     never by a tier change, so this is an addition Bon asked for rather than a behaviour
     being copied line for line. That distinction is worth stating out loud: the SHAPE is
     the lander's included add on rule, the trigger is new.

     UNCLAIMING STILL WORKS, and it is the only way to drop the bridge on those tiers. The
     claim happens on the TRANSITION into headworn or loadout, not on every emit, so a
     customer who unticks the bridge while sitting on FULL LOADOUT stays unticked: the
     payload drops PRED-BRIDGE and the compare at falls by its value, exactly as before.
     Re entering the tier from another tier claims it again, which is the same "the tier
     decides what is in the kit" behaviour as the four component checkboxes.

     lastTier is the transition detector. It is seeded from the initial state so the very
     first paint cannot fire a claim the customer did not ask for. */
  function tierClaimsBridge(tier) { return tier === 'headworn' || tier === 'loadout'; }
  var lastTier = 'core';
  function applyTierBridge(nextTier) {
    if (nextTier === lastTier) { lastTier = nextTier; return; }
    var entering = tierClaimsBridge(nextTier) && !tierClaimsBridge(lastTier);
    lastTier = nextTier;
    if (entering && !state.bridge) {
      state.bridge = true;
      try { sessionStorage.setItem(BRIDGE_KEY, '1'); } catch (e) {}
    }
  }
  function emit() { for (var i = 0; i < subs.length; i++) { try { subs[i](get()); } catch (e) { if (window.console) console.error('[no-predator] subscriber', e); } } }
  function get() {
    var t = TIERS[state.tier];
    var extras = 0;
    if (state.lens13 && !t.lens13) extras += ADDON_PRICE.lens13;
    if (state.g24 && !t.g24) extras += ADDON_PRICE.g24;
    if (state.flip && !t.flip) extras += ADDON_PRICE.flip;
    var kitPrice = round2(t.price + extras);
    var kitCompare = round2(t.compare + extras - (state.bridge ? 0 : BRIDGE_VALUE));
    var helmetPrice = state.helmet ? state.helmet.price : 0;
    var price = round2(kitPrice + helmetPrice);
    var compare = round2(kitCompare + helmetPrice);
    return {
      tier: state.tier, name: t.name, tierPrice: t.price, tierCompare: t.compare,
      lens13: state.lens13, g24: state.g24, flip: state.flip,
      bridge: state.bridge, bridgeValue: BRIDGE_VALUE,
      helmet: state.helmet ? { id: state.helmet.id, price: state.helmet.price, title: state.helmet.title } : null,
      included: { lens13: t.lens13, g24: t.g24, flip: t.flip },
      kitPrice: kitPrice, kitCompare: kitCompare,
      price: price, compare: compare, save: round2(compare - price),
      isTier: extras === 0, locked: isLocked()
    };
  }
  function select(tier) {
    if (!TIERS[tier]) return;
    var t = TIERS[tier];
    state.tier = tier; state.lens13 = t.lens13; state.g24 = t.g24; state.flip = t.flip;
    applyTierBridge(tier);   // PDP-KIT-4: MOUNT KIT and FULL LOADOUT claim the free bridge
    emit();
  }
  function toggle(key) {
    if (!(key in ADDON_PRICE)) return;
    var next = { lens13: state.lens13, g24: state.g24, flip: state.flip };
    next[key] = !next[key];
    var tier = mapTier(next);          // up on a tick, down on an untick: the tier is a pure function of the set
    state.tier = tier; state.lens13 = next.lens13; state.g24 = next.g24; state.flip = next.flip;
    applyTierBridge(tier);   // PDP-KIT-4: reaching MOUNT KIT or FULL LOADOUT by ticking claims it too
    emit();
  }
  function set(key, on) {
    if (!(key in ADDON_PRICE)) return;
    if (!!state[key] === !!on) return;
    toggle(key);
  }
  function setBridge(on) {
    on = !!on;
    /* PDP-KIT-4: an explicit unclaim while already on a claiming tier is the customer
       overruling the tier, and it must stick. Because applyTierBridge only ever fires on a
       transition INTO headworn or loadout, nothing re claims it until the tier is left and
       re entered, so no extra bookkeeping is needed here. This comment exists so the next
       reader does not "fix" it by re claiming on every emit. */
    if (state.bridge === on) return;
    state.bridge = on;
    try { sessionStorage.setItem(BRIDGE_KEY, on ? '1' : '0'); } catch (e) {}
    emit();
  }
  function toggleBridge() { setBridge(!state.bridge); }
  function setHelmet(v) {
    // v: null | { id, price, title }
    var next = v && v.id ? { id: Number(v.id), price: Number(v.price) || 0, title: String(v.title || '') } : null;
    var same = (!next && !state.helmet) || (next && state.helmet && next.id === state.helmet.id && next.price === state.helmet.price);
    if (same) return;
    state.helmet = next;
    emit();
  }
  function items() {
    var out = [{ id: VARIANTS.core, quantity: 1 }];
    if (state.bridge) out.push({ id: VARIANTS.bridge, quantity: 1 });
    if (state.lens13) out.push({ id: VARIANTS.lens13, quantity: 1 });
    if (state.g24) out.push({ id: VARIANTS.g24, quantity: 1 });
    if (state.flip) out.push({ id: VARIANTS.flip, quantity: 1 });
    if (state.helmet) out.push({ id: state.helmet.id, quantity: 1 });
    return out;
  }

  /* ---------------------------------------------------------------- cart */
  var busy = false;
  function cartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }
  function sectionIds(cart) {
    try {
      if (cart && typeof cart.getSectionsToRender === 'function') {
        return cart.getSectionsToRender().map(function (s) { return s.section || s.id; }).filter(Boolean);
      }
    } catch (e) {}
    return [];
  }
  function addToCart(btn, done) {
    if (busy) return false;
    if (isLocked()) return false;
    busy = true;
    var payload = { items: items() };
    var cart = cartElement();
    var ids = sectionIds(cart);
    if (ids.length) { payload.sections = ids.join(','); payload.sections_url = window.location.pathname; }
    if (btn) { btn.setAttribute('disabled', 'disabled'); btn.setAttribute('aria-busy', 'true'); }
    document.dispatchEvent(new CustomEvent('no-predator:adding', { detail: payload }));
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body && res.body.description ? res.body.description : 'Add to cart failed');
        document.dispatchEvent(new CustomEvent('no-predator:added', { detail: res.body }));
        var opened = false;
        try {
          if (cart && typeof cart.renderContents === 'function' && res.body && res.body.sections) {
            if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(res.body);
            opened = true;
          }
        } catch (e) { opened = false; if (window.console) console.warn('[no-predator] drawer render failed, falling back to /cart', e); }
        if (window.Shopify && window.Shopify.onCartUpdate) { try { window.Shopify.onCartUpdate(); } catch (e) {} }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (!opened) window.location.href = '/cart';
        busy = false;
        if (btn) { btn.removeAttribute('disabled'); btn.removeAttribute('aria-busy'); }
        if (done) done(null, res.body);
      })
      .catch(function (err) {
        busy = false;
        if (btn) { btn.removeAttribute('disabled'); btn.removeAttribute('aria-busy'); }
        if (window.console) console.error('[no-predator] add to cart:', err);
        document.dispatchEvent(new CustomEvent('no-predator:error', { detail: String(err && err.message || err) }));
        if (done) done(err);
      });
  }

  /* ---------------------------------------------------------------- ticking */
  var tickers = [];
  var wasLocked = isLocked();
  function tick() {
    var ms = remainingMs();
    for (var i = 0; i < tickers.length; i++) { try { tickers[i](ms); } catch (e) {} }
    if (wasLocked && ms <= 0) { wasLocked = false; emit(); document.dispatchEvent(new CustomEvent('no-predator:unlocked')); }
  }
  setInterval(tick, 250);

  var api = window.NOPredatorKit = {
    VARIANTS: VARIANTS, TIERS: TIERS, ADDON_PRICE: ADDON_PRICE, BRIDGE_VALUE: BRIDGE_VALUE, DROP_MS: DROP_MS,
    fmt: fmt, fmtWhole: fmtWhole, clock: clock, parts: parts, pad: pad,
    get: get, select: select, toggle: toggle, set: set, items: items, mapTier: mapTier,
    tierClaimsBridge: tierClaimsBridge,   // PDP-KIT-4
    setBridge: setBridge, toggleBridge: toggleBridge, setHelmet: setHelmet,
    addToCart: addToCart, isLocked: isLocked, remainingMs: remainingMs,
    subscribe: function (fn) { subs.push(fn); fn(get()); return function () { var i = subs.indexOf(fn); if (i >= 0) subs.splice(i, 1); }; },
    onTick: function (fn) { tickers.push(fn); fn(remainingMs()); }
  };

  /* ================================================================ DOM: kit selector */
  function bindKit() {
    var root = document.getElementById('no-predator-kit');
    if (!root || root.hasAttribute('data-no-bound')) return;
    root.setAttribute('data-no-bound', '1');

    var radios = $$('input[name="no-pk-tier"]', root);
    var cards = $$('[data-no-pk-card]', root);
    var addons = $$('[data-no-pk-addon]', root);
    var nameEl = $('[data-no-pk-name]', root);
    var totalEl = $('[data-no-pk-total]', root);
    var compareEl = $('[data-no-pk-compare]', root);
    var saveEl = $('[data-no-pk-save]', root);
    var cta = $('[data-no-pk-cta]', root);
    var lock = $('[data-no-pk-lock]', root);
    var lockClock = $('[data-no-pk-lock-clock]', root);
    var lockUnits = { days: $('[data-no-pk-u="days"]', root), hours: $('[data-no-pk-u="hours"]', root), minutes: $('[data-no-pk-u="minutes"]', root), seconds: $('[data-no-pk-u="seconds"]', root) };
    var err = $('[data-no-pk-error]', root);
    // bridge row
    var bridgeRow = $('[data-no-pk-bridge]', root);
    var bridgeInput = bridgeRow ? $('input', bridgeRow) : null;
    var bridgeRedeem = $('[data-no-pk-redeem]', root);
    var bridgeClaimed = $('[data-no-pk-claimed]', root);
    var bridgeBadge = $('[data-no-pk-bridge-badge]', root);
    // helmet upsell
    var helmetBox = $('[data-no-pk-helmet]', root);

    radios.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) api.select(r.value); });
    });
    addons.forEach(function (row) {
      var key = row.getAttribute('data-no-pk-addon');
      var input = $('input', row);
      if (!input) return;
      input.addEventListener('change', function () { api.set(key, input.checked); });
    });
    if (bridgeInput) bridgeInput.addEventListener('change', function () { api.setBridge(bridgeInput.checked); });
    if (bridgeRedeem) bridgeRedeem.addEventListener('click', function (ev) { ev.preventDefault(); api.setBridge(true); });
    if (cta) {
      cta.addEventListener('click', function (ev) {
        ev.preventDefault();
        if (err) { err.hidden = true; err.textContent = ''; }
        api.addToCart(cta, function (e) { if (e && err) { err.textContent = String(e.message || e); err.hidden = false; } });
      });
    }

    // ---- helmet upsell (only rendered by Liquid when a helmet resolves for this
    // market: the GEN II inside the US, the GEN I outside it. See bindHelmet.)
    var helmet = null;
    if (helmetBox) helmet = bindHelmet(helmetBox);
    api.helmetMarket = helmet ? helmet.market : null;
    api.helmetHandle = helmet ? helmet.handle : null;

    api.subscribe(function (s) {
      radios.forEach(function (r) { r.checked = r.value === s.tier; });
      cards.forEach(function (c) { c.classList.toggle('is-selected', c.getAttribute('data-no-pk-card') === s.tier); });
      addons.forEach(function (row) {
        var key = row.getAttribute('data-no-pk-addon');
        var input = $('input', row);
        var price = $('[data-no-pk-addon-price]', row);
        var inc = s.included[key];
        if (input) { input.checked = !!s[key]; input.disabled = false; }
        row.classList.toggle('is-included', !!inc);
        row.classList.toggle('is-on', !!s[key]);
        if (price) price.textContent = inc ? 'INCLUDED' : fmt(ADDON_PRICE[key]);
      });
      if (bridgeRow) {
        if (bridgeInput) bridgeInput.checked = s.bridge;
        bridgeRow.classList.toggle('is-on', s.bridge);
        if (bridgeRedeem) bridgeRedeem.hidden = s.bridge;
        if (bridgeClaimed) bridgeClaimed.hidden = !s.bridge;
        if (bridgeBadge) bridgeBadge.hidden = s.bridge;
      }
      if (nameEl) nameEl.textContent = s.name + (s.helmet ? ' + HELMET' : '');
      if (totalEl) totalEl.textContent = fmt(s.price);
      if (compareEl) compareEl.textContent = fmt(s.compare);
      if (saveEl) { saveEl.textContent = 'SAVE ' + fmtWhole(s.save); saveEl.hidden = s.save <= 0; }
      if (cta) { cta.hidden = s.locked; cta.disabled = s.locked; }
      if (lock) lock.hidden = !s.locked;
      if (helmet) helmet.render(s);
    });
    api.onTick(function (ms) {
      if (!lock || lock.hidden) return;
      var p = parts(ms);
      if (lockClock) lockClock.textContent = clock(ms);
      if (lockUnits.days) lockUnits.days.textContent = pad(p.days);
      if (lockUnits.hours) lockUnits.hours.textContent = pad(p.hours);
      if (lockUnits.minutes) lockUnits.minutes.textContent = pad(p.minutes);
      if (lockUnits.seconds) lockUnits.seconds.textContent = pad(p.seconds);
    });
  }

  /* ================================================================ DOM: helmet upsell row

     Branch PDP-KIT-3, 2026-09-04. Two changes against PREDATOR-LIVE-2.

     1. MARKET. Bon: "can u make the checkbox upsell for the helmet our gen 1
        helmet for non US markets? so for US markets it should show gen 2 helmet
        only, and gen 1 helmet for our non US markets like Canada, UK, rest of
        world etc." The CHOICE is made in Liquid, not here: the block resolves
        all_products['fast-sf-helmet'] inside the US and the GEN I listing
        outside it, and prints the resolved product's own title, image, price and
        variants into the row. So this function never names a handle and never
        names a market. It reads whatever the server rendered, which is what
        makes the variant id in the cart payload correct per market even from a
        cached page. api.setHelmet already carries the id straight into items().

        The only thing that changes here is that the GEN I listing has ONE
        variant with the option value "Default Title", where the GEN II has SIZE
        and COLOR. The select builder already skipped a lone Default Title
        option, so the international row renders with no dropdowns at all, which
        is correct: there is nothing to choose. The out of stock note and the
        availability guard work identically on one variant and on six.

     2. THE DROPDOWNS. Bon: "lets make both the helmet addon upsell
        variant/options dropdown containers more in our site typography and theme
        it looks like a generic dropdown right now." Instead of creating a bare
        <select>, this now clones the <template data-no-pk-select-tpl> the Liquid
        renders, which carries the theme's own picker markup: a .select wrapper,
        a .select__select control and the theme's .icon-caret SVG. base.css then
        styles it exactly like every other picker in the store, and
        predator-kit3.css adds the eyebrow, the Rajdhani face and the accent.
        It stays a real <select>, so the option list is still the operating
        system's and a screen reader still announces a combo box.
        The template is optional: if it is missing the old bare markup is built,
        so an asset that failed to apply degrades instead of throwing. */
  function bindHelmet(box) {
    var dataEl = $('script[data-no-pk-helmet-data]', box);
    var data = null;
    try { data = JSON.parse(dataEl ? dataEl.textContent : 'null'); } catch (e) { data = null; }
    if (!data || !data.variants || !data.variants.length) { box.hidden = true; return null; }
    var variants = data.variants.filter(function (v) { return v && v.id; });
    var optionNames = (data.options || []).map(function (o) { return typeof o === 'string' ? o : (o && o.name) || ''; });
    var input = $('input[type="checkbox"]', box);
    var selWrap = $('[data-no-pk-helmet-options]', box);
    var priceEl = $('[data-no-pk-helmet-price]', box);
    var compareEl = $('[data-no-pk-helmet-compare]', box);   // PDP-KIT-4
    var img = $('[data-no-pk-helmet-img]', box);
    var note = $('[data-no-pk-helmet-note]', box);
    var tpl = $('template[data-no-pk-select-tpl]', box);
    var selects = [];

    // Build one labelled control per option, values in catalogue order. A lone
    // "Default Title" option is not a choice, so it renders nothing: that is the
    // GEN I listing outside the US.
    optionNames.forEach(function (name, i) {
      var key = 'option' + (i + 1);
      var values = [];
      variants.forEach(function (v) { if (v[key] && values.indexOf(v[key]) < 0) values.push(v[key]); });
      if (!values.length || (values.length === 1 && values[0] === 'Default Title')) return;

      var wrap, labelEl, sel;
      if (tpl && tpl.content && tpl.content.firstElementChild) {
        wrap = tpl.content.firstElementChild.cloneNode(true);
        labelEl = wrap.querySelector('.no-pk__helmet-opt-label');
        sel = wrap.querySelector('select');
      }
      if (!wrap || !sel) {
        // fallback: the pre PDP-KIT-3 shape, unstyled but functional
        wrap = document.createElement('span');
        wrap.className = 'no-pk__helmet-opt';
        labelEl = document.createElement('span');
        labelEl.className = 'no-pk__helmet-opt-label';
        wrap.appendChild(labelEl);
        sel = document.createElement('select');
        wrap.appendChild(sel);
      }
      if (labelEl) labelEl.textContent = name;
      sel.setAttribute('data-no-pk-helmet-opt', key);
      sel.setAttribute('aria-label', name);
      values.forEach(function (val) {
        var o = document.createElement('option');
        o.value = val;
        o.textContent = val;
        o.setAttribute('data-no-pk-label', val);
        sel.appendChild(o);
      });
      if (selWrap) selWrap.appendChild(wrap);
      selects.push({ key: key, el: sel });
    });

    function matchFor(overrideKey, overrideValue) {
      return variants.filter(function (v) {
        return selects.every(function (s) {
          var want = s.key === overrideKey ? overrideValue : s.el.value;
          return v[s.key] === want;
        });
      })[0] || null;
    }
    function current() { return matchFor(null, null); }
    function priceOf(v) { var p = Number(v.price); return p > 500 ? p / 100 : p; } // Liquid json and the .js endpoint both give cents
    /* PDP-KIT-4: the same cents heuristic for the compare. A variant with no compare set
       falls back to the product level figure the block printed into data.compareAt, and
       0 means "there is none", which sync() reads as nothing to show. */
    function compareOf(v) {
      var c = Number(v && v.compare_at_price);
      if (!c) c = Number(data.compareAt || 0);
      if (!c) return 0;
      return c > 500 ? c / 100 : c;
    }
    function imageOf(v) {
      var fi = v.featured_image;
      if (fi && fi.src) return fi.src;
      if (typeof fi === 'string') return fi;
      /* PDP-KIT-4: '' means "this variant has no image of its own", and sync() then
         leaves whatever Liquid rendered alone. That is what lets the GEN I keep the
         transparent predator-thumb-helmet-gen1.png asset instead of having the listing's
         white background photo written back over it on the first paint. */
      return '';
    }
    // Mark the option values that lead to a combination which cannot be bought
    // right now, so the state is visible in the list rather than only after the
    // choice. predator-kit3.css dims them.
    function markOptions() {
      selects.forEach(function (s) {
        Array.prototype.forEach.call(s.el.options, function (o) {
          var base = o.getAttribute('data-no-pk-label') || o.value;
          var v = matchFor(s.key, o.value);
          if (v && v.available) {
            o.removeAttribute('data-no-pk-oos');
            o.disabled = false;
            o.textContent = base;
          } else {
            /* HELMET SIZE PICKER RULE (2026-09-19): a value that leads only to
               sold out stock is greyed AND cannot be chosen, and says so in
               words rather than only by colour. */
            o.setAttribute('data-no-pk-oos', '1');
            o.disabled = true;
            o.textContent = base + ' - Sold out';
          }
        });
      });
    }

    /* If the value the select landed on cannot be bought, move to the first one
       that can, so nobody is left holding a sold out size by default. */
    function selectFirstAvailable() {
      var moved = false;
      selects.forEach(function (s) {
        var cur = matchFor(s.key, s.el.value);
        if (cur && cur.available) return;
        var opts = Array.prototype.slice.call(s.el.options);
        for (var i = 0; i < opts.length; i++) {
          var v = matchFor(s.key, opts[i].value);
          if (v && v.available) { s.el.value = opts[i].value; moved = true; break; }
        }
      });
      return moved;
    }
    function sync() {
      var v = current();
      var ok = !!(v && v.available);
      if (priceEl) priceEl.textContent = v ? fmt(priceOf(v)) : '';
      /* PDP-KIT-4, Bon: "Gen 1 helmet has no compared at". The compare comes from the
         variant Shopify rendered (or the product level one the block printed as a
         fallback), never from a constant here: the theme's own product_upsell block
         applies no discount of its own, it simply lets the listing's compare_at_price
         do the saving, so reproducing "the same discount as the checkbox for heat and
         viper" means rendering what Shopify already carries. It is hidden whenever it
         is missing or not actually higher than the price, so no market ever shows a
         struck through duplicate of its own price. */
      if (compareEl) {
        var cmp = v ? compareOf(v) : 0;
        var p = v ? priceOf(v) : 0;
        if (cmp > p) { compareEl.textContent = fmt(cmp); compareEl.hidden = false; }
        else { compareEl.textContent = ''; compareEl.hidden = true; }
      }
      /* PDP-KIT-4: only a variant that HAS an image may overwrite the rendered one. */
      if (img && v) { var src = imageOf(v); if (src && img.getAttribute('src') !== src) img.setAttribute('src', src); }
      if (note) { note.hidden = ok; note.textContent = ok ? '' : 'This size and colour combination is not available right now.'; }
      if (input) { input.disabled = !ok; if (!ok && input.checked) input.checked = false; }
      markOptions();
      api.setHelmet(input && input.checked && ok ? { id: v.id, price: priceOf(v), title: data.title || '' } : null);
    }
    selects.forEach(function (s) { s.el.addEventListener('change', sync); });
    if (input) input.addEventListener('change', sync);
    markOptions();
    selectFirstAvailable();
    sync();
    return {
      market: data.market || (box.getAttribute('data-no-pk-helmet-market') || ''),
      handle: data.handle || (box.getAttribute('data-no-pk-helmet-handle') || ''),
      render: function (s) {
        box.classList.toggle('is-on', !!s.helmet);
        var row = $('.no-pk__addon', box); if (row) row.classList.toggle('is-on', !!s.helmet);
        if (input && !input.disabled) input.checked = !!s.helmet;
      }
    };
  }

  /* ================================================================ DOM: theme buy button + price block */
  function bindTheme() {
    var kitRoot = document.getElementById('no-predator-kit');
    if (!kitRoot) return;
    var info = kitRoot.closest('.product__info-container') || kitRoot.closest('[id^="ProductInfo-"]') || document;
    var form = $('product-form.main-product-form form, form[data-type="add-to-cart-form"]', info) || $('form[action*="/cart/add"]', info);
    var submit = form ? $('.product-form__submit, [type="submit"][name="add"]', form) : null;
    var label = submit ? $('.main-atc__label__text', submit) : null;
    var labelText = label ? label.textContent : '';

    if (submit && !submit.hasAttribute('data-no-bound')) {
      submit.setAttribute('data-no-bound', '1');
      submit.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        if (api.isLocked()) return;
        api.addToCart(submit);
      }, true);
    }
    if (form && !form.hasAttribute('data-no-bound')) {
      form.setAttribute('data-no-bound', '1');
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        if (api.isLocked()) return;
        api.addToCart(submit);
      }, true);
    }

    var priceBox = $('[id^="price-"]', info);
    function syncPrice(s) {
      if (!priceBox) return;
      $$('.price__sale .price-item--sale, .price__regular .price-item--regular', priceBox).forEach(function (el) { el.textContent = fmt(s.price); });
      $$('.price__compare-price s, .price__compare-price .price-item--regular', priceBox).forEach(function (el) { el.textContent = fmt(s.compare); });
      $$('.price__badge-sale .nowrap', priceBox).forEach(function (el) { el.textContent = 'SAVE ' + fmtWhole(s.save); });
    }
    api.subscribe(function (s) {
      syncPrice(s);
      if (submit) {
        if (s.locked) {
          submit.setAttribute('disabled', 'disabled');
          submit.setAttribute('aria-disabled', 'true');
          submit.classList.add('no-pk-theme-locked');
        } else {
          submit.removeAttribute('disabled');
          submit.removeAttribute('aria-disabled');
          submit.classList.remove('no-pk-theme-locked');
          if (label && labelText) label.textContent = labelText;
        }
      }
    });
    api.onTick(function (ms) {
      if (!submit || !label || ms <= 0) return;
      label.textContent = 'OPENS IN ' + clock(ms);
    });
  }

  function init() { bindKit(); bindTheme(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
}());

/* 2026-09-04 main, Bon: "when customer selects the kit packages... automatically rotate to the right image per kit".
   The theme gallery keeps its own thumbnails; on a tier CHANGE (not the first paint, the hero stays) the flat lay
   of that kit becomes the active media. Uses the theme's media-gallery element when present, else presses the
   thumbnail button. Fails silent when the images are renamed. */
(function () {
  var KIT_IMG = { core: 'COREkitflatlay', headworn: 'HEADWORNkitflatlay', loadout: 'FULLLOADOUTkitflatlay' };
  var first = true, last = null;
  function show(tier) {
    var want = KIT_IMG[tier]; if (!want) return;
    var items = document.querySelectorAll('.thumbnail-list__item'); var li = null;
    for (var i = 0; i < items.length; i++) {
      var img = items[i].querySelector('img'); var src = img && (img.getAttribute('src') || img.getAttribute('srcset') || '');
      if (src && src.indexOf(want) >= 0) { li = items[i]; break; }
    }
    if (!li) return;
    var id = li.getAttribute('data-target'); var gal = document.querySelector('media-gallery');
    if (gal && id && typeof gal.setActiveMedia === 'function') { try { gal.setActiveMedia(id, true); return; } catch (e) {} }
    var b = li.querySelector('button'); if (b) b.click();
  }
  function arm() {
    var k = window.NOPredatorKit; if (!k || typeof k.subscribe !== 'function') return false;
    k.subscribe(function (s) { if (first) { first = false; last = s.tier; return; } if (s.tier === last) return; last = s.tier; show(s.tier); });
    return true;
  }
  if (!arm()) { var n = 0, t = setInterval(function () { if (arm() || ++n > 40) clearInterval(t); }, 250); }
})();
